/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.221.0-v202611042125-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqApprovalFlowAttachmentsApiClass {
 
   constructor() {}

  /**
   * @summary Attach an Approval Flow-supported item to an approval flow without approving any step
   * @param {string} flowId - The Seeq ID of the approval flow
  */
  public createApprovalFlowAttachment(
    body: models.ApprovalFlowAttachmentInputV1,
    {
      flowId
    } : {
      flowId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (flowId === null || flowId === undefined) {
      throw new Error("'flowId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/approval-flows/${encodeURIComponent(String(flowId))}/attachments`
      .replace('{flowId}', encodeURIComponent(String(flowId)));
    const urlTemplate = `${baseUrl}/approval-flows/{flowId}/attachments`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ApprovalFlowAttachmentOutputV1>;
  }

  /**
   * @summary Get a single approval flow attachment by id
   * @param {string} itemId - The Seeq ID of the Approval Flow-supported item
   * @param {string} id - The Seeq ID of the approval flow attachment
   * @param {boolean} [includeArchived=false] - Return the attachment even if it (or its flow) is archived
  */
  public getApprovalFlowAttachment(
    {
      itemId,
      id,
      includeArchived
    } : {
      itemId: string,
      id: string,
      includeArchived?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/approval-flows/${encodeURIComponent(String(itemId))}/attachments/${encodeURIComponent(String(id))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/approval-flows/{itemId}/attachments/{id}`;

    const queryParams = {
      ['includeArchived']: includeArchived
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ApprovalFlowAttachmentOutputV1>;
  }

  /**
   * @summary List the approval flow attachments for an Approval Flow-supported item
   * @param {string} itemId - The Seeq ID of the Approval Flow-supported item
   * @param {boolean} [includeArchived=false] - Include archived attachments
   * @param {number} [offset=0] - Pagination offset
   * @param {number} [limit=40] - Page size
  */
  public listApprovalFlowAttachments(
    {
      itemId,
      includeArchived,
      offset,
      limit
    } : {
      itemId: string,
      includeArchived?: boolean,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/approval-flows/${encodeURIComponent(String(itemId))}/attachments`
      .replace('{itemId}', encodeURIComponent(String(itemId)));
    const urlTemplate = `${baseUrl}/approval-flows/{itemId}/attachments`;

    const queryParams = {
      ['includeArchived']: includeArchived,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ApprovalFlowAttachmentOutputListV1>;
  }

}


export const sqApprovalFlowAttachmentsApi = new sqApprovalFlowAttachmentsApiClass();

export type sqApprovalFlowAttachmentsApiEndpoints = {
  'createApprovalFlowAttachment': {
    method: 'post';
    path: '/approval-flows/${encodeURIComponent(String(flowId))}/attachments';
    response: models.ApprovalFlowAttachmentOutputV1;
  };
  'getApprovalFlowAttachment': {
    method: 'get';
    path: '/approval-flows/${encodeURIComponent(String(itemId))}/attachments/${encodeURIComponent(String(id))}';
    response: models.ApprovalFlowAttachmentOutputV1;
  };
  'listApprovalFlowAttachments': {
    method: 'get';
    path: '/approval-flows/${encodeURIComponent(String(itemId))}/attachments';
    response: models.ApprovalFlowAttachmentOutputListV1;
  };
};

type ApiCreateApprovalFlowAttachmentResponse = models.ApprovalFlowAttachmentOutputV1;
type ApicreateApprovalFlowAttachmentMutationParams = Parameters<typeof sqApprovalFlowAttachmentsApi.createApprovalFlowAttachment> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqApprovalFlowAttachmentsApi.createApprovalFlowAttachment>;

export function useApiCreateApprovalFlowAttachmentMutation(
  options?: Omit<UseMutationOptions<ApiCreateApprovalFlowAttachmentResponse, AxiosError<SeeqErrorData>,
    ApicreateApprovalFlowAttachmentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateApprovalFlowAttachmentResponse, AxiosError<SeeqErrorData>,
  ApicreateApprovalFlowAttachmentMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApicreateApprovalFlowAttachmentMutationParams) =>
      sqApprovalFlowAttachmentsApi.createApprovalFlowAttachment(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetApprovalFlowAttachmentResponse = models.ApprovalFlowAttachmentOutputV1;
export function GetApprovalFlowAttachmentQueryKey(
  params: Parameters<typeof sqApprovalFlowAttachmentsApi.getApprovalFlowAttachment>[0],
) {
  return ['sqApprovalFlowAttachmentsApi', 'getApprovalFlowAttachment', params] as const;
}

export function useApiGetApprovalFlowAttachmentQuery(
  params: Parameters<typeof sqApprovalFlowAttachmentsApi.getApprovalFlowAttachment>[0],
  options?: Omit<UseQueryOptions<ApiGetApprovalFlowAttachmentResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetApprovalFlowAttachmentResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetApprovalFlowAttachmentQueryKey(params),
    queryFn: () =>
      sqApprovalFlowAttachmentsApi.getApprovalFlowAttachment(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiListApprovalFlowAttachmentsResponse = models.ApprovalFlowAttachmentOutputListV1;
export function ListApprovalFlowAttachmentsQueryKey(
  params: Parameters<typeof sqApprovalFlowAttachmentsApi.listApprovalFlowAttachments>[0],
) {
  return ['sqApprovalFlowAttachmentsApi', 'listApprovalFlowAttachments', params] as const;
}

export function useApiListApprovalFlowAttachmentsQuery(
  params: Parameters<typeof sqApprovalFlowAttachmentsApi.listApprovalFlowAttachments>[0],
  options?: Omit<UseQueryOptions<ApiListApprovalFlowAttachmentsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiListApprovalFlowAttachmentsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: ListApprovalFlowAttachmentsQueryKey(params),
    queryFn: () =>
      sqApprovalFlowAttachmentsApi.listApprovalFlowAttachments(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
